import axios from '@lib/axios';
import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

interface Request {
	//includesNewsletterLists: boolean;
}

interface Props {
  agendaId?: string;
	onSuccess?: (res: AxiosResponse) => void;
  onError?: (res: AxiosError) => void;
}

export const useSendAgenda = ({
  agendaId,
	onSuccess,
  onError
}: Props) => {
	const {
		mutate: onSendAgenda,
		...rest
	} = useMutation({
		//mutationFn: async ({ includesNewsletterLists }: Request) => axios.post(`/agendas/${agendaId}/send`, { includesNewsletterLists }),
		mutationFn: async () => axios.post(`/agendas/${agendaId}/send`),
		onSuccess,
    onError
	});

	return { onSendAgenda, ...rest };
};